.ux-w-missions {
    display: block;

    .ux-w-wrapper__body {
        > div {
            display: flex;
        }
    }

    &__empty .ux-w-empty__background {
        font-size: 455px;
        transform: translateY(-50px);
    }

    &__item {
        display: inline-flex;
        flex-direction: column;
        width: 300px;
        padding: 20px;
        position: relative;

        &:nth-of-type(even) {
            background: $color-blue-menu-bg;
        }
    }

    &__assignment-type {
        margin-bottom: 10px;
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.1;
    }

    &__week-container {
        padding-left: 20px;
        position: relative;
        display: inline-flex;
    }

    &__week-number {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 20px;
        background-color: $color-blue-highlight-3;
        color: #fff;
        font-weight: bold;
        font-size: 13px;

        &__text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-90deg);
            white-space: nowrap;
        }
    }

    &__date {
        background-color: $color-blue-highlight-1;
        color: #fff;
        border-radius: 4px;
        padding: 0 20px 0 70px;
        height: 50px;
        position: relative;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        line-height: 1.2;
        margin: 0 0 15px;
        font-family: "Frutiger-Light", sans-serif;
        font-weight: 400;

        &__day {
            position: absolute;
            width: 60px;
            left: 5px;
            top: 0;
            text-align: center;
            transform: translateY(50%);
            font-size: 40px;
            font-weight: bold;
            line-height: 0.65;
            font-family: "Frutiger-Web", sans-serif;
        }
    }

    &__status {
        margin-bottom: 15px;
    }

    &__alias {
        font-weight: bold;
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        text-transform: uppercase;

        &::after {
            content: "";
            position: absolute;
            display: block;
            right: 0;
            top: 0;
            bottom: 0;
            width: 50px;
            background: linear-gradient(
                90deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 1) 100%
            );
        }
    }

    &__equipment {
        line-height: 1.2;
    }

    &__label {
        text-transform: uppercase;
        margin-top: 20px;
    }

    &__button {
        position: absolute;
        right: 20px;
        bottom: 20px;
    }
}
